import React from 'react';
import { FadeIn } from './FadeIn';
export function PainSection() {
  const painPoints = ['Revisás el WhatsApp cada 5 minutos esperando que aparezca su nombre', 'Escribís mensajes largos explicando todo… y él no responde o responde con monosílabos', '"Contacto cero" que solo enfría más la conexión y te destruye por dentro', 'Llorás a las 3 AM preguntándote si hay alguien más o si ya no le importás', 'Amigos y familia te dicen "olvidalo" pero nadie entiende lo que sentís', 'Intentaste todo: súplicas, amenazas, ignorarlo, buscar magia oscura... y nada funcionó', 'Tenés miedo de que cada día que pasa sea un día más lejos del retorno'];
  return <section className="py-16 px-4 bg-miel-darker relative border-t border-miel-crimson/10" data-id="element-191">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-lg h-px bg-gradient-to-r from-transparent via-miel-crimson to-transparent opacity-50" data-id="element-192" />

      <div className="max-w-4xl mx-auto" data-id="element-193">
        <FadeIn data-id="element-194">
          <h2 className="font-playfair text-3xl md:text-5xl text-center text-miel-cream mb-8 leading-tight" data-id="element-195">
            ¿Cuántas noches más vas a pasar{' '}
            <span className="text-miel-crimson italic" data-id="element-196">
              mirando el teléfono así?
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-197">
          <div className="text-center mb-8 space-y-6 text-lg text-miel-cream/80" data-id="element-198">
            <p data-id="element-199">
              Vos lo querés. Sabés que hay algo real entre ustedes. Pero hay un
              muro invisible hecho de orgullo, silencio y palabras que ninguno
              sabe cómo desarmar.
            </p>
            <p className="text-xl font-playfair text-miel-gold italic border-b border-miel-gold/30 pb-6 inline-block" data-id="element-200">
              No es falta de amor. Es falta de un sistema.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-10" data-id="element-201">
          {painPoints.map((point, index) => <FadeIn key={index} delay={0.1 * index} direction="left" data-id="element-202">
              <div className="flex items-start gap-4 bg-miel-dark/50 p-4 rounded-lg border border-miel-crimson/10 hover:border-miel-crimson/30 transition-colors" data-id="element-203">
                <span className="text-miel-red mt-1 shrink-0" data-id="element-204">❌</span>
                <p className="text-miel-cream/90" data-id="element-205">{point}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-206">
          <div className="text-center" data-id="element-207">
            <h3 className="font-playfair text-2xl md:text-3xl text-miel-goldLight italic" data-id="element-208">
              ¿Y si este fuera el último fin de semana que pasás sola esperando?
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
}